import { useTranslation } from 'react-i18next'
import { useAppSelector } from '../../../../redux/hooks.ts'
import { selectThemeStyle } from '../../../../features/setting/setting.slice.ts'
import Row from 'antd/es/grid/row'
import { convertPxToNumber } from '../../../../utils/helpers.ts'
import IdeyaTypography from '../../../../common/antd/ideya-typography.tsx'
import Col from 'antd/es/grid/col'
import { useIsMobile } from '../../../../common/hooks/use-is-mobile.ts'
import IdeyaRangePicker from '../../../../common/antd/ideya-rangepicker.tsx'
import { USER_CONTROL_COL } from '@/common/constants/user-controls-layout.ts'
import dayjs from 'dayjs'
import { useDispatch } from 'react-redux'
import {
  selectDashboardInput,
  setDashboardInputDateRange,
} from '../../../../redux/slices/dashboard-input.slice.ts'

export const DashboardUserControls = () => {
  const { t } = useTranslation()
  const themeStyle = useAppSelector(selectThemeStyle)
  const isMobile = useIsMobile(768)
  const dispatch = useDispatch()
  const dashboardInput = useAppSelector(selectDashboardInput)

  return (
    <Row
      style={{ marginBottom: themeStyle.marginSM }}
      gutter={[
        convertPxToNumber(themeStyle.marginBase),
        convertPxToNumber(themeStyle.marginBase),
      ]}
    >
      <Col xs={24} md={USER_CONTROL_COL.dateRange}>
        {!isMobile && (
          <Row style={{ paddingBottom: themeStyle.paddingXS }}>
            <IdeyaTypography.Text>
              {t('common.user_controls.time_interval')}
            </IdeyaTypography.Text>
          </Row>
        )}
        <Row>
          <Col span={24}>
            <IdeyaRangePicker
              value={[
                dayjs(dashboardInput.dateRange[0]),
                dayjs(dashboardInput.dateRange[1]),
              ]}
              onChange={(dates) => {
                dispatch(
                  setDashboardInputDateRange([
                    dates?.[0] ? dates[0].toISOString() : null,
                    dates?.[1] ? dates[1].toISOString() : null,
                  ])
                )
              }}
            />
          </Col>
        </Row>
      </Col>
    </Row>
  )
}
